<cloudigo-nav-bar [class.unrendered]="!shouldShowFrame()"/>
<canvas class="app-overlay" id="snowfall-element"></canvas>
<router-outlet/>
<div class="f-main-center initial-loader svg-loader">
    <object data="/old/cloudigo_loader.svg" type="image/svg+xml"></object>
</div>
<cloudigo-footer [class.unrendered]="!shouldShowFrame()"/>